import * as v from 'valibot'

// URL state is shared by direct links, reloads and history restoration.
const bool = v.optional(v.fallback(v.boolean(), false))
export const discoverSearch = v.object({
  page: v.optional(v.fallback(v.pipe(v.number(), v.integer(), v.minValue(1)), 1)),
  solo: bool,
  magnets: bool,
  trailer: bool,
  fav: bool,
  tag: v.optional(v.fallback(v.string(), '')),
  since: v.optional(v.fallback(v.picklist(['any', '30d', 'year']), 'any')),
  sortBy: v.optional(v.fallback(v.picklist(['releaseDate', 'crawledAt']), 'releaseDate')),
  dir: v.optional(v.fallback(v.picklist(['desc', 'asc']), 'desc')),
})
